import SearchBar from './components/searchBar';

export default SearchBar;